import React from 'react';
import '../../styles/NotFoundStyle/index.css';

const NotFound = () => {
  return <div className="NotFound-bg"></div>;
};

export default NotFound;
